import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function Services() {
return (
<>
<Helmet>
<title>Roofing Services | Apex Specialty Contracting LLC � Tampa Bay, FL</title>
<meta name="description" content="Expert roofing services in Tampa Bay: roof replacement, storm damage repair, insurance claims assistance, gutter installation, and commercial roofing. Licensed & insured. Call (916) 316-0696." />
</Helmet>
<PageHeader
title="Our Roofing Services"
subtitle="From a simple repair to a full storm restoration � we handle every roofing need with quality materials and expert craftsmanship."
/>

{/* Residential Roofing */}
<section className="section">
<div className="container">
<h2>Residential Roofing</h2>
<p className="helper">We protect the homes of Florida families with durable, beautiful roofing systems installed by licensed professionals.</p>
<div className="grid grid-3 features" style={{ marginTop: 20 }}>
<div className="card feature fade-up">
<div className="icon-circle">
<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12L12 3l9 9M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
</div>
<h3>Roof Replacement</h3>
<p className="helper">Full tear-off and replacement with premium asphalt shingles, metal, concrete tile, or flat roofing. We help you choose the best system for your home's style, climate challenges, and budget.</p>
<ul className="helper" style={{ paddingLeft: 16, marginTop: 8 }}>
<li>Architectural &amp; 3-tab shingles</li>
<li>Metal roofing (standing seam &amp; corrugated)</li>
<li>Concrete &amp; clay tile</li>
<li>Flat &amp; low-slope systems</li>
</ul>
</div>
<div className="card feature fade-up" style={{ animationDelay: '80ms' }}>
<div className="icon-circle">
<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 2.5c0 1.5-1.5 7-1.5 7h-2C10.5 9.5 9 4 9 2.5a2.5 2.5 0 015 0z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9v11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M8 12H5a1 1 0 00-1 1v7h8M16 12h3a1 1 0 011 1v7h-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
</div>
<h3>Storm Damage Repair</h3>
<p className="helper">Florida storms can cause serious damage quickly. Our rapid-response team assesses, documents, and repairs damage from hurricanes, hail, high winds, and fallen debris.</p>
<ul className="helper" style={{ paddingLeft: 16, marginTop: 8 }}>
<li>24-hour emergency tarping</li>
<li>Wind &amp; hail damage repair</li>
<li>Debris removal &amp; cleanup</li>
<li>Detailed damage documentation for insurance</li>
</ul>
</div>
<div className="card feature fade-up" style={{ animationDelay: '160ms' }}>
<div className="icon-circle">
<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.5"/><path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
</div>
<h3>Insurance Claims Assistance</h3>
<p className="helper">Navigating an insurance claim after a storm is stressful. We make it easier by working directly with your adjuster, providing thorough documentation, and advocating for a fair settlement.</p>
<ul className="helper" style={{ paddingLeft: 16, marginTop: 8 }}>
<li>On-site adjuster meetings</li>
<li>Detailed photo documentation &amp; damage reports</li>
<li>Xactimate-compatible estimates</li>
<li>Supplement &amp; re-inspection support</li>
</ul>
</div>
<div className="card feature fade-up">
<div className="icon-circle">
<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5"/><path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
</div>
<h3>Free Roof Inspection</h3>
<p className="helper">Not sure about the condition of your roof? Our certified inspectors will assess every component and provide a detailed written report at no charge and with no obligation to hire us.</p>
<ul className="helper" style={{ paddingLeft: 16, marginTop: 8 }}>
<li>Shingle condition &amp; granule loss assessment</li>
<li>Flashing, ridge, &amp; valley inspection</li>
<li>Attic ventilation &amp; insulation check</li>
<li>Gutter &amp; drainage evaluation</li>
</ul>
</div>
<div className="card feature fade-up" style={{ animationDelay: '80ms' }}>
<div className="icon-circle">
<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9h18M3 9a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke="currentColor" strokeWidth="1.5"/></svg>
</div>
<h3>Gutter Installation &amp; Repair</h3>
<p className="helper">Gutters are your roof's unsung hero. Properly installed gutters direct water away from your foundation, siding, and landscaping. We offer seamless gutters, gutter guards, and downspout extensions.</p>
<ul className="helper" style={{ paddingLeft: 16, marginTop: 8 }}>
<li>Seamless aluminum &amp; copper gutters</li>
<li>Gutter guard installation</li>
<li>Downspout extensions &amp; re-routing</li>
<li>Cleaning &amp; repair</li>
</ul>
</div>
<div className="card feature fade-up" style={{ animationDelay: '160ms' }}>
<div className="icon-circle">
<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3v4M6.34 6.34l2.83 2.83M3 12h4M6.34 17.66l2.83-2.83M12 21v-4M17.66 17.66l-2.83-2.83M21 12h-4M17.66 6.34l-2.83 2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
</div>
<h3>Skylight &amp; Ventilation</h3>
<p className="helper">Proper attic ventilation extends roof life and reduces energy costs. We install and repair ridge vents, soffit vents, power attic fans, and skylights with watertight flashing.</p>
<ul className="helper" style={{ paddingLeft: 16, marginTop: 8 }}>
<li>Ridge &amp; soffit vent installation</li>
<li>Power attic ventilators</li>
<li>Skylight installation &amp; re-flashing</li>
<li>Attic insulation assessment</li>
</ul>
</div>
</div>
</div>
</section>

{/* Commercial Roofing */}
<section className="section section-alt">
<div className="container two-col">
<div className="img-frame fade-up">
<img src="https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop" alt="Commercial roofing team on a flat roof" />
</div>
<div className="fade-up" style={{ animationDelay: '100ms' }}>
<h2>Commercial Roofing</h2>
<p className="helper">We provide commercial roofing solutions for office buildings, retail centers, warehouses, and industrial facilities throughout the Tampa Bay area. Our commercial team works around your schedule to minimize disruption.</p>
<div style={{ marginTop: 16 }}>
<div className="check-item">
<div className="check-icon">?</div>
<div><strong>TPO Roofing</strong><p className="helper">Energy-efficient thermoplastic polyolefin membranes ideal for flat &amp; low-slope commercial roofs.</p></div>
</div>
<div className="check-item">
<div className="check-icon">?</div>
<div><strong>EPDM Rubber Roofing</strong><p className="helper">Durable, cost-effective rubber membranes with excellent UV and weather resistance.</p></div>
</div>
<div className="check-item">
<div className="check-icon">?</div>
<div><strong>Modified Bitumen</strong><p className="helper">Multi-ply asphalt systems for high-traffic commercial roofs requiring superior durability.</p></div>
</div>
<div className="check-item">
<div className="check-icon">?</div>
<div><strong>Metal Roofing Systems</strong><p className="helper">Standing seam and through-fastened metal panels for long-lasting commercial &amp; industrial applications.</p></div>
</div>
</div>
<Link className="btn" to="/contact" style={{ marginTop: 20, display: 'inline-block' }}>Request a Commercial Quote</Link>
</div>
</div>
</section>

{/* Warranty */}
<section className="section">
<div className="container">
<div style={{ textAlign: 'center', marginBottom: 24 }}>
<h2>Our Warranty Promise</h2>
<p className="helper" style={{ maxWidth: 520, margin: '0 auto' }}>Every project comes with two layers of protection: the manufacturer's material warranty and our own workmanship warranty.</p>
</div>
<div className="grid" style={{ marginTop: 16 }}>
<div className="card" style={{ padding: 22 }}>
<h3>Manufacturer Warranty</h3>
<p className="helper">We install materials from top manufacturers including GAF, Owens Corning, and CertainTeed. These products come with manufacturer warranties ranging from 25 years to lifetime, covering material defects.</p>
</div>
<div className="card" style={{ padding: 22 }}>
<h3>5-Year Workmanship Warranty</h3>
<p className="helper">In addition to the manufacturer warranty, Apex backs every installation with a 5-year workmanship warranty. If any issue arises from our installation, we return and fix it at absolutely no cost to you.</p>
</div>
</div>
</div>
</section>

{/* CTA */}
<section className="section cta-section">
<div className="container" style={{ textAlign: 'center' }}>
<h2>Ready to Get Started?</h2>
<p className="helper" style={{ maxWidth: 480, margin: '0 auto 20px' }}>Contact us today for a free, no-obligation roof inspection and estimate from our licensed team.</p>
<div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
<Link className="btn" to="/contact">Get a Free Estimate</Link>
<a className="btn-outline" href="tel:9163160696">Call (916) 316-0696</a>
</div>
</div>
</section>
</>
);
}

export default Services;